import { DataGridPremium, GridColDef, itIT } from '@mui/x-data-grid-premium';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MovementVersionDialog from '../components/MovementVersionDialog';
import { useMovementVersionsColumns } from '../hooks/useMovementVersionsColumns';
import { IVersion } from '../types';
import { logService } from '../api/log.service';

//** */
export const MovementVersionsPage = () => {
  const translationPrefix = 'pages.versions.movement';
  const [selectedVersion, setSelectedVersion] = useState<any>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [versions, setVersions] = useState<IVersion[]>([]);
  const [rowCount, setRowCount] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  const { t } = useTranslation();
  useEffect(() => {
    setLoading(true);
    const offset = page * pageSize;
    logService
      .getAllPaginated(pageSize, offset, { model_name: 'movement' })
      .then((response) => {
        setVersions(response.results);
        setRowCount(Number(response.count ?? response.results?.length ?? 0));
      })
      .finally(() => setLoading(false));
  }, [page, pageSize]);

  const handleOpenDialog = (id: string) => {
    const version = versions.find((v) => v.id === Number(id));
    setSelectedVersion(version);
    setDialogOpen(true);
  };

  const columns: GridColDef[] = useMovementVersionsColumns(handleOpenDialog);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <div style={{ height: 1000, width: '100%' }}>
        <DataGridPremium
          density="compact"
          rows={versions}
          loading={loading}
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          sx={{ border: 'none', height: '75vh' }}
          disableRowSelectionOnClick
          pagination
          paginationMode="server"
          rowCount={rowCount}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(newModel) => {
            setPage(newModel.pageSize !== pageSize ? 0 : newModel.page);
            setPageSize(newModel.pageSize);
          }}
          pageSizeOptions={[10, 20, 50]}
          columns={columns}
        />
      </div>
      {selectedVersion && (
        <MovementVersionDialog
          open={dialogOpen}
          onClose={() => {
            setSelectedVersion(null);
            setDialogOpen(false);
          }}
          versionId={selectedVersion?.id}
        />
      )}
    </TenantPage>
  );
};

export default MovementVersionsPage;
